/* Heali market-specific inventory overrides
 *
 * This is the safe all-product source of truth for market-local stockouts:
 * - true  = behave as sold out for that market: show native Rez alert, Sold Out badge, hide ATC
 * - false = normal behavior; Rez only shows if Shopify/Rez considers it globally out of stock
 *
 * Current Storefront token does not expose per-location inventory quantities,
 * so this explicit map prevents false positives while covering every live product.
 */
window.HEALI_LOCAL_OOS_OVERRIDES = window.HEALI_LOCAL_OOS_OVERRIDES || {
  ca: {
    "focus-headache-patch": false,
    "relax-headache-patch": false,
    "cloud-pouches": false,
    "refresh-water-bottle": false,
    "on-the-go-packing-cube": false,
    "heali-sticker-sheet": false,
    "stick-snap-phone-mount": false,
    "cowboy-charm": false,
    "pearl-charm": false,
    "cherry-charm": false,
    "everyday-tote": false,
    "bulk-roll-uncut-black-tape-with-inspirational-words": false,
    "fit-case": false,
    "kinesiology-tape-black-tape-with-black-heali-logo": false,
    "beauty-face-tape": false,
    "jaw-pain-strips": false,
    "blue-claw-wide-strips": false,
    "black-claw-wide-strip": false,
    "black-tape-with-black-zebra-design": false,
    "nude-tape-with-zebra-designsplatter-paint-design": false,
    "kinesiology-tape-nude-tape-with-inspirational-words": false,
    "blue-camo-tape": false,
    "blue-tape-with-inspirational-words": false,
    "heali-tape-splatter-paint-design": false,
    "pink-splatter-paint-design-kinesiology-tape": false,
    "eco-beige": false,
    "eco-black": false,
    "pink-camo-tape": false,
    "heali-pregnancy-tape": false,
    "womens-wellness-patch": false,
    "p-m-period-patch": false,
    "healis-a-m-period-patch": false,
    "heali-tape-infused-with-magnesium-menthol-bulk-roll-uncut-blue-splatter-5cm-x-35m": false
  },
  us: {
    "focus-headache-patch": false,
    "relax-headache-patch": false,
    "cloud-pouches": false,
    "refresh-water-bottle": false,
    "on-the-go-packing-cube": false,
    "heali-sticker-sheet": false,
    "stick-snap-phone-mount": false,
    "cowboy-charm": false,
    "pearl-charm": false,
    "cherry-charm": false,
    "everyday-tote": false,
    "bulk-roll-uncut-black-tape-with-inspirational-words": false,
    "fit-case": false,
    "kinesiology-tape-black-tape-with-black-heali-logo": false,
    "beauty-face-tape": false,
    "jaw-pain-strips": false,
    "blue-claw-wide-strips": false,
    "black-claw-wide-strip": false,
    "black-tape-with-black-zebra-design": false,
    "nude-tape-with-zebra-designsplatter-paint-design": false,
    "kinesiology-tape-nude-tape-with-inspirational-words": false,
    "blue-camo-tape": false,
    "blue-tape-with-inspirational-words": false,
    "heali-tape-splatter-paint-design": false,
    "pink-splatter-paint-design-kinesiology-tape": false,
    "eco-beige": false,
    "eco-black": false,
    "pink-camo-tape": false,
    "heali-pregnancy-tape": false,
    "womens-wellness-patch": false,
    "p-m-period-patch": false,
    "healis-a-m-period-patch": false,
    "heali-tape-infused-with-magnesium-menthol-bulk-roll-uncut-blue-splatter-5cm-x-35m": false
  }
};

window.healiIsLocalOosOverride = window.healiIsLocalOosOverride || function(market, productHandle) {
  var overrides = window.HEALI_LOCAL_OOS_OVERRIDES || {};
  return !!(overrides[market] && overrides[market][productHandle] === true);
};
